export const determineStyle = (status) => {
  switch (status) {
    case "offline":
      return {
        background: "#828791",
        color: "#000",
      };
    case "unavailable":
    case "out_of_service":
    case "fault":
      return {
        background: "#c01515",
        color: "#fff",
      };
    case "firmware_update":
    case "self_check":
    case "operator":
    case "charging":
      return {
        background: "#ffca28",
        color: "#272525",
      };
    case "reserved":
      return {
        background: "#819cfd",
        color: "#272525",
      };
    case "available":
    default:
      return {
        background: "#00e676",
        color: "#272525",
      };
  }
};
